import { UI_LinkList } from 'ui/components/3-organisms/LinkList/LinkList';

export const LinkList = ({ content }: Content.LinkList) => {
	const { heading, linkListItems, headingLink } = content ?? {};
	return <UI_LinkList heading={heading} headingLink={headingLink} linkListItems={linkListItems} />;
};
